import React, { useState, useEffect, } from 'react';
import TextField from '@mui/material/TextField';
import { Checkbox, Stack, Chip, Tooltip, FormHelperText, LinearProgress, FormControl, Button, MenuItem, Modal, CssBaseline, Menu, ListItemText, AppBar, Toolbar, Grid, Box, Card, CardContent, Dialog, DialogContent, Autocomplete, TableContainer, Table, TableCell, TableBody, TableHead, TableRow, Typography, useTheme, IconButton, Divider, DialogTitle, alpha, } from '@mui/material';

import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";
import 'dayjs/locale/en';
import axios from 'axios';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

import Backicon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Saveicon from '@mui/icons-material/SaveOutlined';
import CancelIcon from '@mui/icons-material/Close';
import Approveicon from '@mui/icons-material/Approval';
import Amendicon from '@mui/icons-material/AutorenewOutlined';
import CancelIcon1 from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ListItemIcon } from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import Searchicon from '@mui/icons-material/Search';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';

import GlobalConfig from '../../../components/GlobalConfig';
import { API_ENDPOINTS } from '../../../config/api/apiCall';
import CustomSnackbar from '../../../components/CustomSnackbar';
import useAutocompleteData from '../../../pages/commonapicall/useAutocompleteData';
import { tokens } from "../../../theme/theme";
import CloseIcon from "@mui/icons-material/Close";
// import DeliverOrderPickListReport from './DeliverOrderPickListReport';
import DeliveryPlanActionMenu from './DeliveryPlanActionMenu';
import { callApi } from '../../../utils/apiClient';
import DeliverOrderPickListReport from '../../ordermanagement/reports/DeliverOrderPickListReport';
import { useMasterDataLoader } from '../../../hooks/useMasterDataLoader';
import CustomTableContainer from '../../../components/table/CustomTableContainer';
import ResponsiveBox from '../../../Layout/ResponsiveScrollBox';
import DateRangePicker from '../../../components/DateRangePicker';
import { Search } from '@mui/icons-material';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const DeliveryOrderList = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [FromCODate, setFromCODate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToCODate, setToCODate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [OrderDate, setOrderDate] = useState(dayjs());
    const [ScheduleDate, setScheduleDate] = useState(dayjs());
    const [LRDate, setLRDate] = useState(dayjs());

    const [Remarks, SetRemarks] = useState('');
    const [LRNo, SeLRNo] = useState('');
    const [isVisible_DespatchPlan, setisVisible_DespatchPlan] = useState(true);
    const [isVisible_CreateDespatchPlan, setisVisible_CreateDespatchPlan] = useState(false);
    const [isVisible_CreateDespatchPlanEntry, setiisVisible_CreateDespatchPlanEntry] = useState(false);
    const [isVisible_DespatchItem, setisVisible_DespatchItem] = useState(false);
    const [isVisible_commanButtons, setisVisible_commanButtons] = useState(false);
    const [isVisible_cancelDetail, setisVisible_cancelDetail] = useState(false);

    const [isVisiblebtnCreateDespatchPlan, setisVisiblebtnCreateDespatchPlan] = useState(true);
    const [isVisiblebtnAddSelectedCO, setisVisiblebtnAddSelectedCO] = useState(false);

    const [isVisibleReelItem, setisVisibleReelItem] = useState(false);
    const [isVisibleSheetItem, setisVisibleSheetItem] = useState(false);

    const [fromModule, SetfromModule] = useState('');
    const [fromSubModule, SetfromSubModule] = useState('');
    const [headerDespatchplan, SetheaderDespatchplan] = useState('New Delivery Order');

    const [btnApprove, setbtnApprove] = useState(false);
    const [btnSaveUpdate, setbtnSaveUpdateOrdershow] = useState(false);
    const [btnAmendment, setbtnAmendmentshow] = useState(false);
    const [btnPrint, setbtnPrint] = useState(false);
    const [btnCancel, setbtnCancel] = useState(false);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertsevierity, setalertsevierity] = useState('');

    const [btnSaveText, setbtnSaveText] = useState('Save');
    const [btnSaveTooltip, setbtnSaveTooltip] = useState('Save Plan');

    let [FinancierYear, setFinancierYear] = useState(1);
    let [LOGIN_USER, setLOGIN_USER] = useState('');

    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);
    const [loading, setLoading] = React.useState(false);

    const [rows, setTableData] = useState([]);

    const [rowsConfirmedOrders, setrowsConfirmedOrders] = useState([]);
    const [rowsDespathPlanList, setrowsDespathPlanList] = useState([]);
    const [filteredData_ConfirmedOrders, setFilteredData_ConfirmedOrders] = useState([]);
    const [searchText_ConfirmedOrders, setSearchText_ConfirmedOrders] = useState('');
    const [selectDespathcPlanList, setselectDespathcPlanList] = useState([]);
    const [selectCOOrders, setselectCOOrders] = useState([]);

    const [Reason, SetReason] = useState('');
    const [cancelDate, setSelectedDate] = React.useState();

    const [ReasonError, setReasonError] = useState("");
    const [DateError, setDateError] = useState("");

    const [SAmendmentReason, SetSAmendmentReason] = useState('');
    const [visibleAmendmentReason, setvisibleAmendmentReason] = useState(false);
    const [amendReasonError, setamendReasonError] = useState("");

    const [selectedItems, setSelectedItems] = useState([]);

    const [DespatchNo, SetDespatchNo] = useState('');
    const [ShipmentOrderNO, SeShipmentOrderNO] = useState('');
    const [DocumentSeries, SeDocumentSeries] = useState(6);
    const [DespatchDate, setDespatchDate] = useState(dayjs());

    const [DespatchNoAF, SetDespatchNoAF] = useState(false);
    const [SLength, SetSLength] = useState('');

    const [iIndentID, setiIndentID] = useState(0);
    const [iConfirmationID, setiConfirmationID] = useState(0);
    const [iDespatchOrderID, setiDespatchOrderID] = useState(0);
    const [iShippedOrderID, setiShippedOrderID] = useState(0);

    const [selectedTransporter, setSelectedTransporter] = useState('');
    const [selectedTruckNo, setSelectedTruckNo] = useState('');
    const [STransporter, setSTransporter] = useState(0);
    const [STruckNo, setSTruckNo] = useState(0);
    const [transporterError, settransporterError] = useState("");
    const [truckNoError, settruckNoError] = useState("");

    const [inputTruckNo, setInputinputTruckNo] = useState('');
    const [CompanyID, setCompanyID] = useState('');

    //  const defaultReportData = {
    //     Header: {
    //         DeliveryOrderNo: "DO-201-2025",
    //         Date: "28-Jul-2025",
    //         TruckNumber: "DL01GC0447",
    //     },
    //     BillTo: {
    //         Parent: "AS PACKERS PROVIDERS (P) LTD",
    //         Name: "AS PACKERS PROVIDERS (P) LTD",
    //     },
    //     ShipTo: {
    //         Name: "AS PACKERS PROVIDERS (P) LTD",
    //     },
    //     Supplier: {
    //         Name: "NETIQUE INFOTECH PRIVATE LIMITED",
    //         Address: "8.5 km, Jansath Road,, Muzaffarnagar UTTAR PRADESH, INDIA 251001",
    //         GSTIN: "09AABCR1065J1ZC",
    //     },
    //     Items: [
    //         {
    //             S_No: 1,
    //             Quality: "AURA",
    //             GSM: "230",
    //             Size: "23.00 x 25.00",
    //             Location: "CLAXA",
    //             Reams_per_Bundle: 38,
    //             No_of_Reels_Bundles: 100,
    //             Weight_Kg: 7220.000,
    //         },
    //     ],
    //     Total: {
    //         TotalQtyKg: 7220.00,
    //     },
    // };
    //   const [reportData] = useState(defaultReportData);
    const [viewreport, setViewReport] = useState(false);
    const [picklistData, setPicklistData] = useState([]);
    const [selectedShipmentMode, setSelectedShipmentMode] = useState('');
    const [Id_ShipmentMode, setId_ShipmentMode] = useState(null);

    const [dataShipmentmode, setdataShipmentmode] = useState([]);
    const [freight, setFreight] = useState(null);
    const [driverContactNo, setDriverContactNo] = useState('');

    const { loadMasterData } = useMasterDataLoader();

    useEffect(() => {
        const fetchMasterData = async () => {
            try {
                const requests = [

                    { group: 'SO_SHIPMENT_MODE', setter: setdataShipmentmode, msg: 'Shipment mode details not found' },

                ];

                await Promise.all(
                    requests.map(req =>
                        loadMasterData(
                            req.endpoint || API_ENDPOINTS.GET_MASTER_LIST,
                            { ...commonParams, masterGroup: req.group, ...(req.extra || {}) },
                            req.setter,
                            req.msg
                        )
                    )
                );
            } catch (error) {
                console.error("Failed to load master data:", error);
            }
        };

        fetchMasterData();
    }, []); // <-- Empty array so it runs only once

    // Handles when an option is selected or user types a new value
    const handleiInputTruckNoChange = (event, newInputValue) => {
        setInputinputTruckNo(newInputValue); // This captures the typed input
    };
    const handleSelectShipmentMode = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedShipmentMode(newValue);
            setId_ShipmentMode(newValue.CodeId);
        }
    };


    const masterGroup = '';
    const commonParams = { FinancierYear, masterGroup, };


    useEffect(() => {
        const retrievedUserID = localStorage.getItem('userID');
        if (retrievedUserID) {
            setCompanyID(localStorage.getItem('companyid'));
        }
    }, []); // Empty dependency array to run only once on mount

    const handleSelectTransporter = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedTransporter(newValue);
            setSTransporter(newValue.CodeId);
        }
    };
    const handleSelectTruckNo = (event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
            setSelectedTruckNo(newValue);
            setSTruckNo(newValue.CodeId);
        }
    };

    const useAutocompleteDataByMasterGroup = (masterGroup) => {
        const data = useAutocompleteData(
            API_ENDPOINTS.GET_MASTER_LIST,
            {
                ...commonParams,
                masterGroup: masterGroup,
            }
        );
        return data;
    };

    const dataTransporter = useAutocompleteDataByMasterGroup('SO_TRANSPORTER');
    const dataTruckNo = useAutocompleteDataByMasterGroup('DO_TRUCKNUMBER');

    var sSelectedItemIDList;

    const [dispatchPlanNo, setDispatchPlanNo] = useState('');



    const LoadShippedOrderList = () => {
        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        } else {
            const formattedFromDate = dayjs(FromDate).format('YYYY-MMM-DD');
            const formattedToDate = dayjs(ToDate).format('YYYY-MMM-DD');

            const requestBody = {
                IndentId: 0,
                ConfirmationOrderId: 0,
                DespatchOrderId: 0,
                ShippedOrderNo: dispatchPlanNo || '',
                ShipmentPlanDateFrom: formattedFromDate,
                ShipmentPlanDateTo: formattedToDate,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: CompanyID,
                },
            };

            fetch(API_ENDPOINTS.LoadShippedOrderList, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to load Shipped Order List');
                    }
                    return response.json();
                })
                .then(data => {

                    if (data && data.length > 0) {
                        const formattedData = data.map((row, index) => {
                            // const DespatchOrderDate = new Date(row.DespatchOrderDate).toLocaleDateString();
                            // const ShippedOrderDate = new Date(row.ShippedOrderDate).toLocaleDateString();

                            return { ...row, id: index + 1 };
                        });

                        setTableData(formattedData);
                    }
                    else {
                        setTableData([]);
                    }


                })
                .catch(error => {
                    showError('Unable to load Shipped Order List', 'error');
                });
        }
    };

    const filterData_ConfirmedOrders = (data) => {
        const filtered = data.filter(row =>
            Object.values(row).some(value =>
                value && value.toString().toLowerCase().includes(searchText_ConfirmedOrders.toLowerCase())
            )
        );
        setFilteredData_ConfirmedOrders(filtered);
    };

    const LoadConfirmedOrderList = () => {
        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        } else {
            const requestBody = {
                FromDate: FromCODate,
                ToDate: ToCODate,
                BillToCustomerID: 0,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: CompanyID,
                },
            };

            fetch(API_ENDPOINTS.loadConfirmedOrderList, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to load confirmation order details');
                    }
                    return response.json();
                })
                .then(data => {
                    const formattedData = data.map((row, index) => {
                        const dateOnly = new Date(row.ConfirmationDate).toLocaleDateString();
                        return { ...row, id: index + 1, dateOnly };
                    });

                    setrowsConfirmedOrders(formattedData);
                    filterData_ConfirmedOrders(formattedData);
                })
                .catch(error => {

                    showError('Unable to load confirmation order details', 'error');
                });
        }
    };

    const LoadDespatchPlanListForDO = () => {
        const ConstructedGlobalValues = {

            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
            COMPANY_ID: CompanyID,

        };

        fetch(API_ENDPOINTS.LoadDespatchPlanListForDO, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(ConstructedGlobalValues)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load Despatch Plan List');
                }
                return response.json();
            })
            .then(data => {
                const formattedData = data.map((row, index) => {
                    //const dateOnly = new Date(row.DespatchOrderDate).toLocaleDateString();
                    return { ...row, id: index + 1 };
                });
                setrowsDespathPlanList(formattedData);
            })
            .catch(error => {

                showError('Unable to load Despatch Plan List', 'error');
            });

    };
    const showSnackbar = () => {
        setSnackbarOpen(true);
    };


    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
    };

    // Automatically load confirmed orders whenever both dates are selected
    useEffect(() => {
        if (FromDate && ToDate) {
            LoadShippedOrderList();
        }
    }, [FromDate, ToDate]);


    const handlerOrderDate = (date) => {
        setOrderDate(dayjs(date));
    };
    const handleScheduleDate = (date) => {
        setScheduleDate(dayjs(date));
    };
    const handleLRDate = (date) => {
        setLRDate(dayjs(date));
    };

    const handleCreateDispatchPlans = () => {
        setisVisible_CreateDespatchPlan(true);
        setisVisible_DespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setisVisible_DespatchItem(false);
        SetfromModule('Despatch Plan List')

        setisVisiblebtnCreateDespatchPlan(true);
        setisVisiblebtnAddSelectedCO(false);

        LoadDespatchPlanListForDO();
    };


    const handleFilterAndSetSelection = (dataArray, setValueFunction, codeIdField, data, setCodeId) => {
        if (dataArray.length > 0) {
            const codeIdValue = data?.[codeIdField];
            const stringCodeIdValue = String(codeIdValue);
            const filteredData = dataArray.filter((item) => item.CodeId === stringCodeIdValue);

            if (filteredData.length > 0) {
                setValueFunction(filteredData[0]);
                setCodeId(codeIdValue);
            }
        }
    };


    const updateReelStock = () => {
        rowsReelItemsFiltered.forEach(oRow => {
            if (oRow.SelectItem) {
                if (headerDespatchplan.toLowerCase() === "New Delivery Order" || headerDespatchplan.toLowerCase() === "Amended Delivery Order") {
                    if (parseFloat(oRow.NoOfReelsShipped) >= 0 && parseFloat(oRow.NoOfReelsPlanned) >= 0 && parseFloat(oRow.NoOfReelsShipped) > parseFloat(oRow.NoOfReelsPlanned)) {
                        showError("Reels Shipped cannot be more than " + oRow.NoOfReelsPlanned.toString(), "error");
                        oRow.NoOfReelsShipped = parseFloat(oRow.NoOfReelsPlanned);
                    }
                }

                let oLineQtyPlanned = 0;
                let oLineReelsPlanned = 0;
                let oLinePerReelWeight = 0;
                if (parseFloat(oRow.NoOfReelsShipped) >= 0 && parseFloat(oRow.ReelWeight) >= 0) {
                    oLineReelsPlanned = parseInt(oRow.NoOfReelsShipped);
                    oLinePerReelWeight = parseFloat(oRow.ReelWeight);
                    oLineQtyPlanned = oLineReelsPlanned * oLinePerReelWeight; // / 1000
                    oRow.QtyShipped = Math.round(oLineQtyPlanned * 10000) / 10000;
                }
            }

        });
        // Assuming you want to update the state with the modified rowsReelItemsFiltered
        setrowsReelItemsFiltered([...rowsReelItemsFiltered]);
    }


    const updateSheetStock = () => {
        rowsSheetItemsFiltered.forEach(oRow => {
            if (oRow.SelectItem) {
                if (headerDespatchplan.toLowerCase() === "New Delivery Order" || headerDespatchplan.toLowerCase() === "Amended Delivery Order") {
                    if (parseFloat(oRow.NoOfBundlesShipped) >= 0 && parseFloat(oRow.NoOfBundlesPlanned) >= 0 && parseFloat(oRow.NoOfBundlesShipped) > parseFloat(oRow.NoOfBundlesPlanned)) {
                        showError("Bundles Shipped cannot be more than " + oRow.NoOfReelsPlanned.toString(), "error");
                        oRow.NoOfBundlesShipped = parseFloat(oRow.NoOfBundlesPlanned);
                    }
                }
                let oLineQtyPlanned = 0;
                let oLineBundlePlanned = 0;
                let oLinePerBundleWeight = 0;

                oLineBundlePlanned = parseInt(oRow.NoOfBundlesShipped);
                oLinePerBundleWeight = parseFloat(oRow.WeightPerBundle);
                oLineQtyPlanned = oLineBundlePlanned * oLinePerBundleWeight;
                oRow.QtyShipped = Math.round(oLineQtyPlanned * 10000) / 10000;
            }
        });
        setrowsSheetItemsFiltered([...rowsSheetItemsFiltered]);
    }


    const ShowDeliveryPackingList = async (requestBody) => {
        try {

            const response = await axios.post(API_ENDPOINTS.generateDeliveryPackingList,
                requestBody,
                {
                    responseType: 'arraybuffer' // Important to receive binary data
                }
            );

            // Extract INVO5 object from response headers             

            // Handle the binary data response as before
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            showError('Delivery order packing list report exported successfully..!', 'success')

        } catch (error) {
            console.error('Error generating report:', error);
            // Handle error
        } finally {
            setLoading(false);
        }
    };

    const ShowDeliveryPickList = async (requestBody) => {
        try {

            await callApi(API_ENDPOINTS.generateDeliveryPickListForViewReport, 'POST',
                { 'Content-Type': 'application/json' }, requestBody)
                .then(data => {
                    if (data) {
                        setViewReport(true);
                        setiisVisible_CreateDespatchPlanEntry(false);
                        setisVisible_DespatchPlan(false);
                        setisVisible_CreateDespatchPlan(false);
                        setisVisible_DespatchItem(false);
                        setisVisible_commanButtons(false);
                        setisVisible_cancelDetail(false);

                        setPicklistData(data);
                    }
                })
                .catch(error => {
                    alert("API Error: " + error.message);
                });


        } catch (error) {
            console.error('Error generating report:', error);
            // Handle error
        } finally {
            setLoading(false);
        }
    };


    const LoadShippedOrderDetail = (requestBody, status) => {
        fetch(API_ENDPOINTS.LoadShippedOrderDetail, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load delivery order details');
                }
                return response.json();
            })
            .then(data => {
                SetheaderDespatchplan(data.SOrderStatus + " Delivery Order");
                SeShipmentOrderNO(data.SShippedOrderNo);
                SetDespatchNo(data.SDespatchPlanNo);
                // setDespatchDate(data.SDespatchPlanDate)
                setDespatchDate(dayjs(data.SDespatchPlanDate).format("DD-MMM-YYYY"));
                setOrderDate(dayjs(data.SOrderDate).format("DD-MMM-YYYY"));
                handleFilterAndSetSelection(dataTransporter, setSelectedTransporter, 'STransporter', data, setSTransporter);
                handleFilterAndSetSelection(dataTruckNo, setSelectedTruckNo, 'STruckNumber', data, setSTruckNo);
                SeLRNo(data.SLRNo);
                setLRDate(dayjs(data.SLRDate).format("DD-MMM-YYYY"));
                if (data.SScheduledDate !== null) {
                    setScheduleDate(dayjs(data.SScheduledDate).format("DD-MMM-YYYY"));
                }
                SetRemarks(data.SRemarks);
                setFreight(data.SFreight);
                setDriverContactNo(data.SDriverContactNumber);
                setId_ShipmentMode(data.SShipmentMode);
                const selectedMode = dataShipmentmode.find(
                    mode => String(mode.CodeId) === String(data.SShipmentMode)
                );

                setSelectedShipmentMode(selectedMode || '');

                setSTruckNo(data.STruckNumber);
                const selectedTruckNumber = dataTruckNo.find(
                    mode => String(mode.CodeId) === String(data.STruckNumber.trim())
                );
                setSelectedTruckNo(selectedTruckNumber || '');

                setSTransporter(data.STransporter);

                const fdata = data.SSalesOrderItems.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsConfirmedOrdersDespacth(fdata);

                const fdata1 = data.DeliveryOrderReelItemsList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsReelItems(fdata1);

                const fdata2 = data.DeliveryOrderSheetItemsList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsSheetItems(fdata2);

                const fdata3 = data.DeliveryOrderQtySummary.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setplannedQtyData(fdata3);

                RefreshStatus(status);
                updateRows(fdata, fdata1, fdata2);
                updateTotalQty(fdata, fdata3, fdata1, fdata2);
                SetfromModule('Despatch Plan List');
                setbtnSaveText('Update');
                setbtnSaveTooltip('Update Delivey Order');
                SetDespatchNoAF(true);
                SetSAmendmentReason('');
            })
            .catch(error => {
                setAlertMessage('Unable to load delivery order details');
                setalertsevierity('error');
                showSnackbar();
            });
    }

    const LoadDespatchOrderDetailForDO = (requestBody, status) => {
        fetch(API_ENDPOINTS.LoadDespatchOrderDetailForDO, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load despatch plan details');
                }
                return response.json();
            })
            .then(data => {

                const fdata = data.map((row, index) => {
                    return { ...row, id: index + 1 };
                });

                setrowsConfirmedOrders(fdata);

                setOpen(true);

            })
            .catch(error => {
                setAlertMessage('Unable to load despatch plan details');
                setalertsevierity('error');
                showSnackbar();
            });
    }

    const updateRows = (rowsConfirmedOrdersDespacth, rowsReelItems, rowsSheetItems) => {

        rowsConfirmedOrdersDespacth.forEach(oRowItem => {
            let SIShipped_Qty = 0;
            let ReelBundleCount = 0;

            rowsReelItems.forEach(oRow => {
                if (oRow.SelectItem) {
                    if (oRowItem.SOrderConfirmationId === oRow.ConfirmationOrderID && oRowItem.SProductID === oRow.ProductID) {
                        SIShipped_Qty += oRow.QtyShipped;
                        ReelBundleCount++;
                    }
                }
            });

            rowsSheetItems.forEach(oRow => {
                if (oRow.SelectItem) {
                    if (oRowItem.SOrderConfirmationId === oRow.ConfirmationOrderID && oRowItem.SProductID === oRow.ProductID) {
                        SIShipped_Qty += oRow.QtyShipped;
                        ReelBundleCount++;
                    }
                }
            });

            SIShipped_Qty = Math.round(SIShipped_Qty, 4);

            // Updating values in the row item
            oRowItem.SIShipped_Qty = SIShipped_Qty;
            oRowItem.ReelBundleCount = ReelBundleCount;
        });

        // Update the state with modified row items
        setrowsConfirmedOrdersDespacth([...rowsConfirmedOrdersDespacth]);
    };


    const LoadConfirmationOrderDetailForDespatchOrder = (requestBody) => {
        fetch(API_ENDPOINTS.LoadDespatchPlanDetailForShipmentUpdate, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load despatch plan details for shipment update');
                }
                return response.json();
            })
            .then(data => {
                SeShipmentOrderNO('Auto');
                if (data.SScheduledDate !== null) {
                    setScheduleDate(data.SScheduledDate);
                }
                SetDespatchNo(data.SDespatchPlanNo);
                setDespatchDate(data.SDespatchPlanDate);
                SetRemarks(data.SRemarks);

                const fdata = data.SSalesOrderItems.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsConfirmedOrdersDespacth(fdata);

                const fdata1 = data.DeliveryOrderReelItemsList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });

                let GlobalReelRows;
                let GlobalSheetRows;

                let updatedReelRows;
                if (rowsReelItems.length > 0) {
                    updatedReelRows = fdata1.map(row => {
                        // Find the corresponding row in rowsSheetItemsFiltered
                        const filteredRow = rowsReelItems.find(filteredRow => filteredRow.id === row.id);

                        // If the filtered row exists and matches the condition, update the SelectItem property
                        if (filteredRow && filteredRow.id === row.id) {
                            // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                            return { ...row, SelectItem: filteredRow.SelectItem };
                        } else {
                            // If the filtered row doesn't exist or doesn't match, keep the row as it is
                            return row;
                        }
                    });
                    setrowsReelItems(updatedReelRows);
                    GlobalReelRows = updatedReelRows;
                }
                else {
                    setrowsReelItems(fdata1);
                    GlobalReelRows = fdata1;
                }


                const fdata2 = data.DeliveryOrderSheetItemsList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });

                let updatedSheetRows;
                if (rowsSheetItems.length > 0) {
                    updatedSheetRows = fdata2.map(row => {
                        // Find the corresponding row in rowsSheetItemsFiltered
                        const filteredRow = rowsSheetItems.find(filteredRow => filteredRow.id === row.id);

                        // If the filtered row exists and matches the condition, update the SelectItem property
                        if (filteredRow && filteredRow.id === row.id) {
                            // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                            return { ...row, SelectItem: filteredRow.SelectItem };
                        } else {
                            // If the filtered row doesn't exist or doesn't match, keep the row as it is
                            return row;
                        }
                    });
                    setrowsSheetItems(updatedSheetRows);
                    GlobalSheetRows = updatedSheetRows;
                }
                else {
                    setrowsSheetItems(fdata2);
                    GlobalSheetRows = fdata2;
                }

                const fdata3 = data.DeliveryOrderQtySummary.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setplannedQtyData(fdata3);

                RefreshStatus('Create');
                SetfromModule('Confirmed Orders');

                updateRows(fdata, GlobalReelRows, GlobalSheetRows);
                updateTotalQty(fdata, fdata3, GlobalReelRows, GlobalSheetRows);


            })
            .catch(error => {
                showError('Unable to load despatch plan details for shipment update', 'error');

            });
    }

    const handleShowDispatchPlansEntry = () => {


        const selectedItems = rowsConfirmedOrders
            .filter(row => row.SelectItem === true) // Filter rows where SelectItem is true
            .map(row => row.SOrderItemId); // Map to SOrderItemId
        setSelectedItems(selectedItems);

        if (selectedItems.length === 0) {
            showError('Please select the order items to include in the despatch plan', 'warning');
            return;
        }

        const sListItemID = selectedItems.join(",");

        setiIndentID(selectDespathcPlanList.IndentId);
        setiConfirmationID(selectDespathcPlanList.ConfirmationOrderId);
        setiDespatchOrderID(selectDespathcPlanList.DespatchOrderId);

        sSelectedItemIDList = sListItemID;

        const requestBody = {
            SOrderId: selectDespathcPlanList.IndentId,
            SOrderConfirmationId: selectDespathcPlanList.ConfirmationOrderId,
            SOrderDespatchOrderId: selectDespathcPlanList.DespatchOrderId,
            SSelectedItemIdList: sListItemID,
            ConstructedGlobalValues: {
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: CompanyID,
            },
        };
        LoadConfirmationOrderDetailForDespatchOrder(requestBody);

    };

    const handleBackTofromDespacthPlanEntry = () => {
        setisVisible_CreateDespatchPlan(false);
        setisVisible_DespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setisVisible_DespatchItem(false);
        setViewReport(false);

        if (fromModule === 'Despatch Plan List') {
            setisVisible_DespatchPlan(true);
        }
        else if (fromModule === 'Confirmed Orders') {
            setisVisible_CreateDespatchPlan(true);
        }
        else if (fromSubModule === 'Despatch Plan Entry') {
            setiisVisible_CreateDespatchPlanEntry(true);
            setisVisible_commanButtons(true);
            SetfromSubModule('');
        }
    }

    const handleCancel = () => {
        setisVisible_cancelDetail(true);
        handleCancelorder();
    }

    const handleOn_OrderItemsCellClick = (params, event) => {
        const iConfirmationID = params.SOrderConfirmationId;
        const iProductID = params.SProductID;

        var updatedDespatchPlanReelStockAvailable1;
        if (params.SILength === 0) {
            updatedDespatchPlanReelStockAvailable1 = rowsReelItems.filter(pItemNew => {
                return (
                    (pItemNew.ConfirmationOrderID === iConfirmationID && pItemNew.ProductID === iProductID)
                );
            });
            setrowsReelItemsFiltered(updatedDespatchPlanReelStockAvailable1);
        }

        else {
            updatedDespatchPlanReelStockAvailable1 = rowsSheetItems.filter(pItemNew => {
                return (
                    (pItemNew.ConfirmationOrderID === iConfirmationID && pItemNew.ProductID === iProductID) ||
                    (pItemNew.OrderRefNo === "SWO" && pItemNew.ProductID === iProductID && (pItemNew.ConfirmationOrderID === iConfirmationID || pItemNew.ConfirmationOrderID === 0))
                );
            });
            setrowsSheetItemsFiltered(updatedDespatchPlanReelStockAvailable1);
        }

        if (params.SILength === 0) {
            setisVisibleReelItem(true);
            setisVisibleSheetItem(false);
        }
        else {
            setisVisibleSheetItem(true);
            setisVisibleReelItem(false);
        }

        SetSLength(params.SILength);
        setisVisible_CreateDespatchPlan(false);
        setisVisible_DespatchPlan(false);
        setisVisible_DespatchItem(true);
        setisVisible_commanButtons(true);
        SetfromSubModule('Despatch Plan Entry');
        handleOpen();
    };

    const handleBackTofromConnfrimOrderList = () => {
        setisVisible_CreateDespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setisVisible_DespatchItem(false);
        setisVisible_DespatchPlan(true);
    }

    const handleOnCellClick = (params, event) => {
        const status = params.ShippedOrderStatus;
        setiIndentID(params.IndentId);
        setiConfirmationID(params.ConfirmationOrderId);
        setiDespatchOrderID(params.DespatchOrderId);
        setiShippedOrderID(params.ShippedOrderId);
        if (params.DespatchOrderId > 0 && params.ShippedOrderId > 0) {
            const requestBody = {
                SOrderShippedOrderId: params.ShippedOrderId,
                SOrderDespatchPlanId: params.DespatchOrderId,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: CompanyID,
                },
            };
            LoadShippedOrderDetail(requestBody, status);
        }
    };



    const handlePrintPackingListClick = (e) => {
        if (iDespatchOrderID > 0 && iShippedOrderID > 0) {
            const requestBody = {
                SOrderDespatchPlanId: iDespatchOrderID,
                SOrderShippedOrderId: iShippedOrderID,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: CompanyID,
                },
            };
            ShowDeliveryPackingList(requestBody);
        }
    };




    const handlePrintPickListClick = (e) => {

        if (iDespatchOrderID > 0 && iShippedOrderID > 0) {
            const requestBody = {
                SOrderDespatchPlanId: iDespatchOrderID,
                SOrderShippedOrderId: iShippedOrderID,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: CompanyID,
                },
            };
            ShowDeliveryPickList(requestBody);
        }
    };



    const handleOnCellClick_DespatchPlanList = (params, event) => {
        const status = params.DespatchOrderStatus;

        setiIndentID(params.IndentId);
        setiConfirmationID(params.ConfirmationOrderId);
        setiDespatchOrderID(params.DespatchOrderId);
        setselectDespathcPlanList(params);

        const requestBody = {
            SOrderId: params.IndentId,
            SOrderConfirmationId: params.ConfirmationOrderId,
            SOrderDespatchOrderId: params.DespatchOrderId,
            ConstructedGlobalValues: {
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: CompanyID,
            },
        };
        LoadDespatchOrderDetailForDO(requestBody, status);
    };

    const RefreshStatus = (status) => {
        setbtnApprove(false);
        setbtnSaveUpdateOrdershow(false);
        setbtnAmendmentshow(false);
        setbtnPrint(false);
        setbtnCancel(false);
        setvisibleAmendmentReason(false)
        if (status === 'New' || status === '[New]') {
            SetheaderDespatchplan('New Delivery Order')
            setbtnSaveUpdateOrdershow(true);
            setbtnCancel(true);
            setbtnApprove(true);
        }
        else if (status === 'Processed') {
            SetheaderDespatchplan('Delivery Order in Process')
            setbtnPrint(true);
        }
        else if (status === 'UnderAmendment') {
            SetheaderDespatchplan('Amended Delivery Order')
            setbtnSaveUpdateOrdershow(true);
            setbtnCancel(true);
            setbtnApprove(true);
        }
        else if (status === 'Cancelled') {
            SetheaderDespatchplan('Delivery Order Cancelled')
        }
        else if (status === 'Approved') {
            SetheaderDespatchplan('Approved Delivery Order')
            setbtnCancel(true);
            setbtnPrint(true);
            setbtnAmendmentshow(true);
            setvisibleAmendmentReason(true);
        }
        else if (status === 'Create') {
            SetheaderDespatchplan('New Delivery Order')
            setbtnSaveUpdateOrdershow(true);
        }
        setisVisible_CreateDespatchPlan(false);
        setisVisible_DespatchPlan(false);
        setiisVisible_CreateDespatchPlanEntry(true);
        setisVisible_commanButtons(true);
        setisVisible_DespatchItem(false);
    }

    const handleEnterReason = (e) => {
        SetReason(e.target.value);
    }
    const handleDateChange = (date) => {
        const selectedDate = new Date(date); // Assuming 'date' is a valid date string
        const formattedDate = selectedDate.toLocaleDateString('en-US');
        setSelectedDate(formattedDate);
    };

    const handleSelectAmendmentReason = (e) => {
        SetSAmendmentReason(e.target.value);
    }






    const columnsConfirmedOrders = [
        {
            field: 'SelectItem',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 80,
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.SelectItem}
                    onChange={(event) => handleCheckboxChangeForConfirmationOrder(event, params.row.id)}
                />
            )
        },
        { field: 'SIConfirmationOrderNo', headerName: 'Order No', width: 80 },
        { field: 'SIVariety', headerName: 'Variety', width: 100 },
        { field: 'SIGSM', headerName: 'GSM', width: 40 },
        {
            field: 'Size', headerName: 'Size', width: 80, renderCell: (params) => <SizeCell_1 row={params.row} />, // Use custom cell renderer
        },
         { field: 'SIColor', headerName: 'Color', width: 80 },
          { field: 'SIUnit', headerName: 'Unit', width: 80 },
        { field: 'SIPlanned_Qty', headerName: 'PlannedQty', width: 80 },
        { field: 'SIShipped_Qty', headerName: 'Shipped Qty', width: 90 },
        { field: 'SIQtyPendingForShipment', headerName: 'Pending Shipment Qty', width: 150 },
        { field: 'SIRemarks', headerName: 'Remarks', width: 150 },
           { field: 'dppaymentterm', headerName: 'Payment Term', width: 150 },
    ];

    const [rowsConfirmedOrdersDespacth, setrowsConfirmedOrdersDespacth] = useState([]);
    const [rowsReelItems, setrowsReelItems] = useState([]);
    const [rowsSheetItems, setrowsSheetItems] = useState([]);
    const [rowsReelItemsFiltered, setrowsReelItemsFiltered] = useState([]);
    const [rowsSheetItemsFiltered, setrowsSheetItemsFiltered] = useState([]);
    const [plannedQtyData, setplannedQtyData] = useState([]);

    const columnsConfirmedOrdersDespacth = [
        {
            field: 'edit',
            headerName: '',
            sortable: false,
            filterable: false,
            width: 5,
            renderCell: (params) => (
                <IconButton onClick={() => handleOn_OrderItemsCellClick(params)}>
                    <EditIcon />
                </IconButton>
            ),
        },
        { field: 'SIConfirmationOrderNo', headerName: 'Confirmation No', width: 100 },
        { field: 'ShipToCity', headerName: 'Ship ToCity', width: 100 },
        { field: 'ShipToState', headerName: 'ShipToState', width: 100 },
        { field: 'SIVariety', headerName: 'Variety', width: 100 },
        { field: 'SIGSM', headerName: 'GSM', width: 50 },
        { field: 'SIWidth', headerName: 'Width', width: 50 },
        { field: 'SILength', headerName: 'Length', width: 50 },
        { field: 'SIColor', headerName: 'Color', width: 50 },
        { field: 'SIUnit', headerName: 'UOM', width: 50 },
        { field: 'SIRequested_Qty', headerName: 'Requested Qty', width: 100 },
        { field: 'SIConfirmed_Qty', headerName: 'Confirmed Qty', width: 100 },
        { field: 'SIPlanned_Qty', headerName: 'Planned Qty', width: 80 },
        { field: 'SIShipped_Qty', headerName: 'Shipped Qty', width: 120 },
        { field: 'SIRemarks', headerName: 'Remarks', width: 120 },
        { field: 'ReelBundleCount', headerName: 'Reel/Bundle', width: 120 }
    ];

    const areAllRowsSelected = () => {
        if (SLength > 0) {
            return rowsSheetItemsFiltered.every(row => row.SelectItem);
        } else {
            return rowsReelItemsFiltered.every(row => row.SelectItem);
        }
    };

    const columnsSheetItems = [
        {
            field: 'SelectItem',
            headerName: '',
            width: 80,
            sortable: false,
            filterable: false,
            renderHeader: () => (
                <Checkbox
                    onChange={handleSelectAllCheckboxChange} checked={areAllRowsSelected()}
                />
            ),
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.SelectItem}
                    onChange={(event) => handleCheckboxChange(event, params.row.id)}
                />
            )
        },
        { field: 'OrderRefNo', headerName: 'STOCK REF.', width: 100 },
        { field: 'Variety', headerName: 'VARIETY', width: 110 },
        { field: 'GSM', headerName: 'GSM', width: 30 },
        { field: 'Width', headerName: 'WIDTH', width: 30 },
        { field: 'Length', headerName: 'LENGTH', width: 40 },
        { field: 'Location', headerName: 'LOCATION', width: 80 },
        { field: 'LotNo', headerName: 'LOT NO', width: 70 },
        { field: 'BundleNumber', headerName: 'BUNDLE NUMBER', width: 150 },
        { field: 'NoOfSheets', headerName: 'SHEETS/REAM', width: 120 },
        { field: 'WeightPerBundle', headerName: 'BUNDLE WEIGHT(KG)', width: 120 },
        { field: 'NoofReams', headerName: 'NO OF REAMS', width: 120 },

    ];

    const columnsReelItems = [
        {
            field: 'SelectItem',
            headerName: '',
            width: 80,
            sortable: false,
            filterable: false,
            renderHeader: () => (
                <Checkbox
                    onChange={handleSelectAllCheckboxChange}
                    checked={areAllRowsSelected()}
                />
            ),
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.SelectItem}
                    onChange={(event) => handleCheckboxChange(event, params.row.id)}
                />
            )
        },


        { field: 'OrderRefNo', headerName: 'STOCK REF.', width: 100 },
        { field: 'Variety', headerName: 'VARIETY', width: 110 },
        { field: 'GSM', headerName: 'GSM', width: 30 },
        { field: 'Width', headerName: 'WIDTH', width: 30 },
        { field: 'Length', headerName: 'LENGTH', width: 30 },
        { field: 'Location', headerName: 'LOCATION', width: 80 },
        { field: 'LotNo', headerName: 'LOT NO', width: 70 },
        { field: 'ReelNumber', headerName: 'REEL NUMBER', width: 150 },
        { field: 'ReelWeight', headerName: 'REEL WEIGHT(KG)', width: 120 },

    ];



    const SizeCell_1 = ({ row }) => {
        const size = `${row.SIWidth} x ${row.SILength}`;

        return (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                {size}
            </div>
        );
    };




    const getStatusProperties = (status) => {
        let label, color, icon, borderColor;

        switch (status) {
            case 'New':
                label = 'New';
                color = '#33691e';
                icon = <ScheduleIcon />;
                borderColor = '#1976d2';
                break;
            case 'Processed':
                label = 'Processed';
                color = '#689f38';
                icon = <PublishedWithChangesIcon />;
                borderColor = '#388e3c';
                break;
            case 'UnderAmendment':
                label = 'Under Amendment';
                color = '#455a64';
                icon = <Amendicon />;
                borderColor = '#f57c00';
                break;
            case 'Cancelled':
                label = 'Cancelled';
                color = '#ff7043';
                icon = <CancelIcon1 />;
                borderColor = '#d32f2f';
                break;
            case 'Approved':
                label = 'Approved';
                color = '#009688';
                icon = <CheckCircleOutlineIcon />;
                borderColor = '#689f38';
                break;
            default:
                label = 'Unknown';
                color = '#9e9e9e'; // Grey color
                icon = null;
                borderColor = '#757575';
        }

        return { label, color, icon, borderColor };
    };

    const StatusCell = ({ value }) => {
        const { label, color, icon, borderColor } = getStatusProperties(value);
        return (
            <Chip
                label={label}
                style={{ backgroundColor: color, color: '#fff', height: '80%', borderColor: borderColor }}
                icon={icon}
            />
        );
    };

    const [selectedOrders, setSelectedOrders] = useState([]);
    const isSelected = (orderId) => selectedOrders.indexOf(orderId) !== -1;
    const [gridAutoRows, setGridAutoRows] = useState(calculateGridAutoRows());

    useEffect(() => {
        const handleResize = () => {
            setGridAutoRows(calculateGridAutoRows());
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        LoadShippedOrderList();
        LoadDespatchPlanListForDO();

    }, []);

    function calculateGridAutoRows() {
        const screenHeight = window.innerHeight;
        const rows = Math.floor((screenHeight - 70) / 3); // Adjust 50 as needed for margins or paddings
        return `${rows}px`;
    }

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);

        const updatedReelRows = rowsReelItems.map(row => {
            // Find the corresponding row in rowsSheetItemsFiltered
            const filteredRow = rowsReelItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            // If the filtered row exists and matches the condition, update the SelectItem property
            if (filteredRow && filteredRow.id === row.id) {
                // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                // If the filtered row doesn't exist or doesn't match, keep the row as it is
                return row;
            }
        });
        setrowsReelItems(updatedReelRows);

        const updatedsheetRows = rowsSheetItems.map(row => {
            // Find the corresponding row in rowsSheetItemsFiltered
            const filteredRow = rowsSheetItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            // If the filtered row exists and matches the condition, update the SelectItem property
            if (filteredRow && filteredRow.id === row.id) {
                // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                // If the filtered row doesn't exist or doesn't match, keep the row as it is
                return row;
            }
        });

        setrowsSheetItems(updatedsheetRows);
        updateReelStock();
        updateSheetStock();
        updateTotalQty(rowsConfirmedOrdersDespacth, plannedQtyData, rowsReelItemsFiltered, rowsSheetItemsFiltered);
    };

    const showError = (message, severity) => {
        setAlertMessage(message);
        setalertsevierity(severity);
        showSnackbar();
        return true;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            LoadShippedOrderList();
        }
    };

    const handleSubmitConfirmationOrder = (event) => {
        event.preventDefault();

        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            LoadConfirmedOrderList();
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleKeyPress = (event) => {
        if (event.altKey && event.key.toLowerCase() === 'c') {
            handleCreateDispatchPlans();
        }
        if (event.altKey && event.key.toLowerCase() === 'p') {
            handleBackTofromConnfrimOrderList();
        }
        if (event.altKey && event.key.toLowerCase() === 'n') {
            handleShowDispatchPlansEntry();
        }
        if (event.altKey && event.key.toLowerCase() === 'b') {
            handleBackTofromDespacthPlanEntry();
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleCreateDispatchPlans, handleBackTofromConnfrimOrderList, handleShowDispatchPlansEntry, handleBackTofromDespacthPlanEntry]);

    const handleCheckboxChange = (event, rowId) => {
        if (SLength > 0) {
            const updatedRows = rowsSheetItemsFiltered.map(row =>
                row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
            );
            setrowsSheetItemsFiltered(updatedRows);
        }
        else {
            const updatedRows = rowsReelItemsFiltered.map(row =>
                row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
            );
            setrowsReelItemsFiltered(updatedRows);
        }
    };

    const handleSelectAllCheckboxChange = (event) => {
        let updatedRows;

        if (SLength > 0) {
            updatedRows = rowsSheetItemsFiltered.map(row => ({ ...row, SelectItem: event.target.checked }));
            setrowsSheetItemsFiltered(updatedRows);
        } else {
            updatedRows = rowsReelItemsFiltered.map(row => ({ ...row, SelectItem: event.target.checked }));
            setrowsReelItemsFiltered(updatedRows);
        }
    };

    const handleCheckboxChangeForConfirmationOrder = (event, rowId) => {
        const updatedRows = rowsConfirmedOrders.map(row =>
            row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
        );
        setrowsConfirmedOrders(updatedRows);

        const filteredData = updatedRows.filter(row => row.SelectItem === true);
        setselectCOOrders(filteredData);
    };





    const handleCancelorder = () => {

        try {
            let formDirty = false;
            let ApproveAndAmend;

            if (headerDespatchplan.trim() === 'invoiced Despatch Plan') {
                ApproveAndAmend = 'invoiced';
            }

            if (!formDirty) {
                if (cancelDate === '') {
                    showError('Cancel date is a required field', 'error');
                    return;
                }
                else if (Reason === '') {
                    showError('Cancel Reason is a required field', 'error');
                    return;
                }
                else {
                    const confirm = window.confirm(`Are you sure want to Cancel this order?, Confirm Cancellation`);

                    if (!confirm) {
                        return;
                    }


                    setLoading(true);

                    const formattedDate = dayjs(cancelDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

                    const clsShippedOrder = {
                        SOrderDespatchPlanId: iDespatchOrderID,
                        SOrderShippedOrderId: iShippedOrderID,
                        SOrderStatus: "Cancelled",
                        SCancelledReason: Reason,
                        SCancelledDate: formattedDate,
                    };

                    const requestBody = {
                        clsShippedOrder: clsShippedOrder,
                        ApproveAndAmend: ApproveAndAmend,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.cancelDeliveryOrderDetails, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to cancel delivery order')
                            }
                            return response.json();
                        })
                        .then(data => {
                            showError(data.returnmsg, 'success');

                            LoadShippedOrderList();
                            RefreshStatus(data.clsShippedOrder.SOrderStatus);
                        })
                        .catch(error => {
                            showError('Unable to cancel delivery order.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error:', error);

        } finally {
            // Stop the progress bar, whether the API call is successful or not
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    }

    const ApproveProcess = () => {

        const formattedOrderDate = dayjs(OrderDate).format('YYYY-MMM-DD');
        const formattedScheduleDate = dayjs(ScheduleDate).format('YYYY-MMM-DD');

        const clsShippedOrder = {
            SOrderDespatchPlanId: iDespatchOrderID,
            SOrderShippedOrderId: iShippedOrderID,
            SScheduledDate: formattedScheduleDate,
            SInvoiceNo: DespatchNo,
            SInvoiceDate: formattedOrderDate,
            SCancelledReason: Reason,
            SCancelledDate: cancelDate,
            SAmendmentReason: SAmendmentReason,
        };

        const requestBody = {
            clsShippedOrder: clsShippedOrder,
            ApproveAndAmend: ApproveAndAmend,
            DocumentSeries: DocumentSeries,
            DocAutoFlag: true,
            ConstructedGlobalValues: {
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: CompanyID,
                LOGIN_USER: LOGIN_USER
            },
            filter: {
                FinancierYear: FinancierYear,
                CompanyID: CompanyID,
                LOGIN_USER: LOGIN_USER
            },
        };

        fetch(API_ENDPOINTS.approve_amend_DeliveyOrderDetails, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to approve delivery order')
                }
                return response.json();
            })
            .then(data => {
                showError(data.returnmsg, 'success');

                LoadShippedOrderList();
                RefreshStatus(data.clsShippedOrder.SOrderStatus);
            })
            .catch(error => {
                showError('Unable to ' + ApproveAndAmend + ' delivery order!', 'error');
            });
    }
    let ApproveAndAmend;

    const handleApproveDeliveryOrderData = (e) => {


        try {
            let formDirty = false;


            if (e === 'Approve Plan') {

                const confirm = window.confirm(`This will Approve this order. Would you like to continue?, Approve order`);

                if (!confirm) {
                    return;
                }
                ApproveAndAmend = 'Approve';
                ApproveProcess();
                return;
            }
            else if (e === 'Amend Plan') {
                const confirm = window.confirm(`This will allow amendment for the Despatch Plan. Would you like to continue?, Amend Despatch Plan`);

                if (!confirm) {
                    return;
                }
                ApproveAndAmend = 'Amend';

                if (SAmendmentReason === '') {
                    formDirty = showError('Amendment Reason is a required field', 'error');
                }

                ApproveProcess();
                return;
            }

            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {

                    setLoading(true);
                    handleSavePlanData(false)(e);
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error:', error);

        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    }

    const handleSavePlanData = (param) => {

        try {
            let formDirty = false;

            if (!selectedTransporter) {
                showError('Transporter is required', 'error');
                return true;
            }


            if (!selectedTruckNo && inputTruckNo === '') {
                showError('Truck No is required', 'error');
                return true;
            }
            if (LRNo === '') {
                showError('LR No is required', 'error');
                return true;
            }

            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {

                    setLoading(true);

                    const formattedOrderDate = dayjs(DespatchDate).format('YYYY-MMM-DD');
                    const formattedScheduleDate = dayjs(ScheduleDate).format('YYYY-MMM-DD');
                    const formattedShipmentDate = dayjs(OrderDate).format('YYYY-MMM-DD');
                    const fLrdata = dayjs(LRDate).format('YYYY-MMM-DD');
                    //                   const finalTruckNo = (STruckNo === '' || STruckNo === 0) ? inputTruckNo : STruckNo;
                    const finalTruckNo = inputTruckNo || STruckNo;

                    const clsShippedOrder = {
                        SOrderDespatchPlanId: iDespatchOrderID,
                        SOrderShippedOrderId: iShippedOrderID,
                        LastUpdatedBy: LOGIN_USER,
                        SRemarks: Remarks,
                        SScheduledDate: formattedScheduleDate,
                        SDespatchPlanNo: DespatchNo,
                        SDespatchPlanDate: formattedOrderDate,
                        SShippedOrderNo: ShipmentOrderNO,
                        SShippedOrderDate: formattedShipmentDate,
                        SInvoiceNo: '',
                        SInvoiceDate: formattedShipmentDate,
                        STransporter: STransporter,
                        STruckNumber: finalTruckNo,
                        SLRNo: LRNo,
                        SLRDate: fLrdata,
                        SSalesOrderItems: rowsConfirmedOrdersDespacth,
                        DeliveryOrderSheetItemsList: rowsSheetItems,
                        DeliveryOrderReelItemsList: rowsReelItems,
                        SShipmentMode: Id_ShipmentMode,
                        SDriverContactNumber: driverContactNo,
                        SFreight: freight
                    };

                    const requestBody = {
                        clsShippedOrder: clsShippedOrder,
                        DocumentSeries: DocumentSeries,
                        DocAutoFlag: true,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },
                        filter: {
                            FinancierYear: FinancierYear,
                            CompanyID: CompanyID,
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.saveDeliveyOrderDetails, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to save delivery order')
                            }
                            return response.json();
                        })
                        .then(data => {
                            if (param) {
                                showError(data.returnmsg, 'success');
                            }

                            setbtnSaveText(data.BtnText);
                            setbtnSaveTooltip(data.BtnText, ' Delivery Order');

                            setiShippedOrderID(data.clsShippedOrder.SOrderShippedOrderId);
                            setiDespatchOrderID(data.clsShippedOrder.SOrderDespatchPlanId);

                            LoadShippedOrderList();
                            LoadConfirmedOrderList();

                            RefreshStatus(data.clsShippedOrder.SOrderStatus);

                            if (param === false) {
                                ApproveProcess();
                            }


                        })
                        .catch(error => {
                            showError('Unable to save delivery order.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            // Handle any errors that occur during the API call
            console.error('Error:', error);

        } finally {
            // Stop the progress bar, whether the API call is successful or not
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };

    const updateTotalQty = (fdata, fdata3, GlobalReelRows, GlobalSheetRows) => {
        // Loop through each row in rowsConfirmedOrdersDespacth
        fdata.forEach(oRowItem => {
            // Initialize SIPlanned_Qty and ReelBundleCount to 0 for each row
            oRowItem.SIShipped_Qty = 0;
            oRowItem.ReelBundleCount = 0;

            // Loop through each row in rowsSheetItems
            GlobalSheetRows.forEach(oRowSheet => {
                if (oRowSheet.SelectItem && oRowItem.SOrderConfirmationId === oRowSheet.ConfirmationOrderID && oRowItem.SProductID === oRowSheet.ProductID) {
                    oRowItem.SIShipped_Qty += oRowSheet.QtyShipped;
                    oRowItem.ReelBundleCount += 1;
                }
            });

            // Loop through each row in rowsReelItems
            GlobalReelRows.forEach(oRowReel => {
                if (oRowReel.SelectItem && oRowItem.SOrderConfirmationId === oRowReel.ConfirmationOrderID && oRowItem.SProductID === oRowReel.ProductID) {
                    oRowItem.SIShipped_Qty += oRowReel.QtyShipped;
                    oRowItem.ReelBundleCount += 1;
                }
            });

            // Round SIPlanned_Qty to 4 decimal places
            oRowItem.SIShipped_Qty = Math.round(oRowItem.SIShipped_Qty * 10000) / 10000;
        });

        // Assuming you want to update the state with the modified rowsConfirmedOrdersDespacth
        setrowsConfirmedOrdersDespacth([...fdata]);


        // Loop through each row in plannedQtyData
        fdata3.forEach(oRowQty => {
            // Initialize TotalQty to 0 for each row
            oRowQty.TotalQty = 0;

            // Loop through each row in rowsConfirmedOrdersDespacth
            fdata.forEach(oRowItem => {
                // Check if the ShipToCity and ShipToState match between the rows
                if (oRowQty.ShipToCity === oRowItem.ShipToCity && oRowQty.ShipToState === oRowItem.ShipToState) {
                    // If there's a match, update TotalQty by adding SIPlanned_Qty from the current row in rowsConfirmedOrdersDespacth
                    oRowQty.TotalQty += oRowItem.SIShipped_Qty;
                }
            });
        });

        // Assuming you want to update the state with the modified plannedQtyData
        setplannedQtyData([...fdata3]);
    }




    const [editPartyID, setEditPartyID] = useState(0)
    const [selectedStatus, setSelectedStatus] = useState('All');

    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openFirst = Boolean(anchorElFirst);
    const openSecond = Boolean(anchorElSecond);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Delivery Order');
    const [selectedOptionFirstOrder, setSelectedOptionFirstOrder] = useState('All Despatch');

    const [openDespatchPlan, setOpenDespatchPlan] = useState(false);






    const [open1, setOpen1] = useState(false);
    const [filters, setFilters] = useState({
        ShippedOrderNo: '',
        ShippedOrderDate: '',
        ShippedOrderStatus: '',
        DespatchOrderNo: '',
        DespatchOrderStatus: '',
    });




    const handleOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const filteredData_DespatchPlan = rows.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.ShippedOrderStatus === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });




    const handleOpenDespatchPlan = () => {
        setOpenDespatchPlan(true);
    };

    const handleCloseDespatchPlan = () => {
        setOpenDespatchPlan(false);
    };



    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };
    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'New') {
            setSelectedStatus('New');
        }
        else if (option === 'Approved') {
            setSelectedStatus('Approved');
        }
        else if (option === 'Cancelled') {
            setSelectedStatus('Cancelled');
        }
        else if (option === 'Under Amendment') {
            setSelectedStatus('Under Amendment');
        }
        else if (option === 'Processed') {
            setSelectedStatus('Processed');
        }
        else if (option === 'All Delivery Order') {
            setSelectedStatus('All');
        }
        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        handleMenuCloseSecond();
    };


    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };

    const handleCallEdit = (value) => {
        setEditPartyID(value);
        handleOnCellClick(value)
    };


    const handleMenuItemClickFirstForOrder = (option) => {
        setSelectedOptionFirstOrder(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'New') {
            setSelectedStatus('New');
        }
        else if (option === 'Approved') {
            setSelectedStatus('Approved');
        }
        else if (option === 'Cancelled') {
            setSelectedStatus('Cancelled');
        }
        else if (option === 'Under Amendment') {
            setSelectedStatus('Under Amendment');
        }
        else if (option === 'Processed') {
            setSelectedStatus('Processed');
        }
        else if (option === 'All Despatch') {
            setSelectedStatus('All');
        }

        setAnchorElFirst(null);
    };

    const handleBackDashboard = () => {
        handleBackWinderMachineEntry();
    }

    return (
        <Box  >

            <CssBaseline />

            {isVisible_DespatchPlan && (
                <>
                    <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                        <Toolbar>
                            {/* First Menu */}
                            <Button
                                color="secondary"
                                onClick={handleMenuClickFirst}
                                endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                            >
                                {selectedOptionFirst}
                            </Button>
                            <Menu
                                anchorEl={anchorElFirst}
                                open={openFirst}
                                onClose={handleMenuCloseFirst}
                            >
                                <MenuItem onClick={() => handleMenuItemClickFirst('All Delivery Order')}>All Delivery Order</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirst('New')}>New</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirst('Approved')}>Approved</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirst('Cancelled')}>Cancelled</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirst('Under Amendment')}>Under Amendment</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirst('Processed')}>Processed</MenuItem>
                            </Menu>

                            {/* Adding margin-left: auto to push the button to the right */}
                            <Tooltip title="Create Delivery Order" >
                                <Button size="small" variant="contained" onClick={handleCreateDispatchPlans} color="secondary" startIcon={<AddIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>
                            </Tooltip>


                            <div>
                                <Tooltip title="View Delivery Order PickList Report">
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="success"
                                        onClick={() => handlePrintPickListClick()}
                                        startIcon={<AddIcon />}
                                        sx={{ textTransform: "none", marginLeft: "10px" }}
                                    >
                                        View DeliverOrder PickList Report
                                    </Button>
                                </Tooltip>




                            </div>

                            {/* Second Menu */}
                            <IconButton
                                size="small"
                                aria-label="menu"
                                sx={{ ml: 2 }}
                                onClick={handleMenuClickSecond}
                            >
                                <MoreVertIcon />
                            </IconButton>

                            <Menu
                                anchorEl={anchorElSecond}
                                open={openSecond}
                                onClose={handleMenuCloseSecond}
                            >
                                <MenuItem onClick={() => handleMenuItemClickSecond('Import Items')}>
                                    <ListItemIcon>
                                        <ImportExportIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Import Items" />
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Items')}>
                                    <ListItemIcon>
                                        <FileDownloadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Items" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                    <ListItemIcon>
                                        <ViewColumnIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Current View" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                    <ListItemIcon>
                                        <ListAltIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Preference " />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                    <ListItemIcon>
                                        <RefreshIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Refresh List" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                    <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                        Reset Columns Width
                                    </Button>
                                </MenuItem>
                            </Menu>

                            <IconButton
                                size="small"
                                aria-label="menu"
                                sx={{ mr: 1, ml: 1 }}
                                onClick={handleMenuClickSecond}
                            >
                                <HelpIcon />
                            </IconButton>

                            <div>
                                <IconButton  >

                                    <Close fontSize="inherit" style={{ color: "#2196F3" }} onClick={handleBackDashboard} />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <CustomSnackbar
                        open={snackbarOpen}
                        message={alertMessage}
                        onClose={handleSnackbarClose}
                        type={alertsevierity}
                    />
                </>
            )}


            {loading && (
                <Box sx={{ width: '100%', marginTop: '10px' }}>
                    <LinearProgress
                        variant="buffer"
                        sx={{
                            '& .MuiLinearProgress-barColorPrimary': {
                                backgroundColor: '#4CAF50', // Green color (you can replace this with your desired color)
                            },
                            '& .MuiLinearProgress-bar2Buffer': {
                                backgroundColor: '#8BC34A', // Another shade of green for the buffer
                            },
                        }}
                        value={progress}
                        valueBuffer={buffer}
                    />
                </Box>
            )}



            {isVisible_DespatchPlan && (
                <form onSubmit={handleSubmit}>
                    <Box>

                        <Grid container spacing={1} p={1} justifyContent="start" style={{ marginTop: '0px' }}>

                            <Grid item lg={2} xs={4}>
                                <FormControl fullWidth size="small">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Order From"
                                            style={{ marginLeft: '10px' }}
                                            id="FromDate"
                                            value={dayjs(FromDate)}
                                            onChange={(date) => handleDateChange2(date)}
                                            slotProps={{ textField: { size: 'small', variant: 'outlined', color: 'secondary' } }}
                                            renderInput={(props) => <TextField {...props} />}
                                            autoFocus
                                            format="DD-MMM-YYYY" // Use the appropriate format string
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>

                            <Grid item lg={2} xs={4}>
                                <FormControl fullWidth size="small" >
                                    <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                        <DatePicker
                                            label="Order To"
                                            id="ToDate"
                                            value={dayjs(ToDate)}
                                            format="DD-MMM-YYYY"
                                            onChange={(date) => handleDateChange1(date)}
                                            slotProps={{ textField: { size: 'small', variant: 'outlined', color: 'secondary' } }}
                                            renderInput={(props) => <TextField {...props} />}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={4} lg={2} xl={2}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    color="secondary"
                                    label="CO No / DO No"
                                    placeholder='Enter the No.'

                                    value={dispatchPlanNo}
                                    onChange={(e) => setDispatchPlanNo(e.target.value)}


                                />
                            </Grid>



                            <Grid item xs={12} sm={4} lg={2} xl={2}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<Search />}
                                    sx={{
                                        height: 32,
                                        px: 2,
                                        fontWeight: 600,
                                        textTransform: "none",
                                        borderRadius: 2,
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                    }}
                                    onClick={LoadShippedOrderList}
                                >
                                    Search
                                </Button>
                            </Grid>
                        </Grid>




                        {/* <DateRangePicker fromDate={FromDate} toDate={ToDate} onFromChange={(date) => handleDateChange2(date)} onToChange={(date) => handleDateChange1(date)} autoFocus /> */}


                        <CustomTableContainer colors={colors}>
                            <TableContainer >
                                <Table size="small" >
                                    <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                        <TableRow>
                                            <TableCell>DONO</TableCell>
                                            <TableCell>DO Date</TableCell>
                                            <TableCell>DO Status</TableCell>
                                            <TableCell>DO Qty</TableCell>
                                            <TableCell>Despatch Plan No</TableCell>
                                            <TableCell>Planned Date</TableCell>
                                            <TableCell>Planned Status</TableCell>
                                            <TableCell>DP Qty</TableCell>

                                            <TableCell>
                                                <IconButton onClick={handleOpenDespatchPlan}>
                                                    <Searchicon style={{ fontSize: "16px" }} />
                                                </IconButton>
                                                <Modal
                                                    open={openDespatchPlan}
                                                    onClose={handleCloseDespatchPlan}
                                                    aria-labelledby="modal-modal-title"
                                                    aria-describedby="modal-modal-description"
                                                >
                                                    <Box style={{ backgroundColor: theme.palette.background.default }} sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                        <TextField
                                                            label="Delivery Order No"
                                                            name="ShippedOrderNo"
                                                            value={filters.ShippedOrderNo}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            color="secondary"
                                                            margin="normal"
                                                            size='small'
                                                        />

                                                        <TextField
                                                            label="Delivery Order Status"
                                                            name="ShippedOrderStatus"
                                                            value={filters.ShippedOrderStatus}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            color="secondary"
                                                            margin="normal"
                                                            size='small'
                                                        />

                                                        <TextField
                                                            label="Despatch Order No"
                                                            name="DespatchOrderNo"
                                                            value={filters.DespatchOrderNo}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            color="secondary"
                                                            margin="normal"
                                                            size='small'
                                                        />

                                                        <TextField
                                                            label="Despatch Order Status"
                                                            name="DespatchOrderStatus"
                                                            value={filters.DespatchOrderStatus}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            color="secondary"
                                                            margin="normal"
                                                            size='small'
                                                        />

                                                        <Button variant="contained" color="secondary" onClick={handleClose} style={{ marginTop: 10 }}>
                                                            Apply Filter
                                                        </Button>
                                                    </Box>
                                                </Modal>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {filteredData_DespatchPlan.map((row, index) => (

                                            <TableRow key={row.DespatchOrderId} sx={{
                                                backgroundColor: index % 2 === 0 ?
                                                    theme.palette.background.default : alpha(theme.palette.action.hover, 0.03),
                                            }}>

                                                <TableCell>
                                                    <span
                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                        onClick={() => handleCallEdit(row)}
                                                    >
                                                        {row.ShippedOrderNo}
                                                    </span>
                                                </TableCell>
                                                <TableCell>{dayjs(row.ShippedOrderDate).format("DD-MMM-YYYY")}</TableCell>
                                                <TableCell>{row.ShippedOrderStatus}</TableCell>
                                                <TableCell sx={{ textAlign: 'right' }}>{row.DOQty}</TableCell>
                                                <TableCell>{row.DespatchOrderNo}</TableCell>
                                                <TableCell>{dayjs(row.DespatchOrderDate).format("DD-MMM-YYYY")}</TableCell>
                                                <TableCell>{row.DespatchOrderStatus}</TableCell>
                                                <TableCell sx={{ textAlign: 'right' }}>{row.DPQty}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CustomTableContainer>
                    </Box>
                </form>
            )}


            {isVisible_CreateDespatchPlan && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        <Button
                            color="secondary"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                            sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                        >
                            {selectedOptionFirstOrder}
                        </Button>
                        <Menu
                            anchorEl={anchorElFirst}
                            open={openFirst}
                            onClose={handleMenuCloseFirst}
                        >
                            <MenuItem onClick={() => handleMenuItemClickFirstForOrder('All Despatch')}>All Despatch</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirstForOrder('New')}>New</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Approved')}>Approved</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Cancelled')}>Cancelled</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Under Amendment')}>Under Amendment</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Processed')}>Processed</MenuItem>
                        </Menu>

                        {/* Spacer to push buttons to the right */}
                        <Box sx={{ flexGrow: 1 }} />

                        <Box>
                            <Tooltip title="Back to Despatch Plan List [Alt + P]" onClick={handleBackTofromConnfrimOrderList}>
                                <Button variant='contained' color="secondary" style={{ marginRight: "2px", textTransform: 'none' }} size='small' startIcon={<Backicon style={{ color: "", }} />} onClick={handleBackTofromConnfrimOrderList}>
                                    Delivery Order List
                                </Button>
                            </Tooltip>
                        </Box>



                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            aria-label="menu"
                            sx={{ ml: 2 }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Import Items')}>
                                <ListItemIcon>
                                    <ImportExportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Import Items" />
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Items')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Items" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                        <IconButton
                            size="small"
                            aria-label="menu"
                            sx={{ mr: 1, ml: 1 }}
                            onClick={handleMenuClickSecond}
                        >
                            <HelpIcon />
                        </IconButton>

                        <div>
                            <IconButton>
                                <Close fontSize="inherit" onClick={handleBackTofromConnfrimOrderList} style={{ color: "#2196F3" }} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>

            )}

            {isVisible_CreateDespatchPlan && (
                <form onSubmit={handleSubmitConfirmationOrder}>
                    <Box>
                        <Grid container spacing={0}>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <CustomTableContainer colors={colors}>
                                    <TableContainer>
                                        <Table size="small">
                                            <TableHead sx={{ height: 10 }}>
                                                <TableRow>

                                                    <TableCell>Despatch Plan No</TableCell>
                                                    <TableCell>Plan Date</TableCell>
                                                    <TableCell>Plan Status</TableCell>
                                                    <TableCell>DP Qty</TableCell>
                                                    <TableCell>DO Qty</TableCell>
                                                    <TableCell>DO Pending Qty</TableCell>
                                                    <TableCell>
                                                        <IconButton onClick={handleOpen1}>
                                                            <Searchicon style={{ fontSize: "16px" }} />
                                                        </IconButton>
                                                        <Modal
                                                            open={open1}
                                                            onClose={handleClose1}
                                                            aria-labelledby="modal-modal-title"
                                                            aria-describedby="modal-modal-description"
                                                        >
                                                            <Box style={{ backgroundColor: 'background.default' }} sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                <TextField
                                                                    label="Despatch Plan No"
                                                                    name="DespatchOrderNo"
                                                                    value={filters.DespatchOrderNo}
                                                                    onChange={handleFilterChange}
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    margin="normal"
                                                                    size="small"
                                                                />
                                                               
                                                                <TextField
                                                                    label="Plan Status"
                                                                    name="DespatchOrderStatus"
                                                                    value={filters.DespatchOrderStatus}
                                                                    onChange={handleFilterChange}
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    margin="normal"
                                                                    size="small"
                                                                />
                                                              
                                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                                    Apply Filter
                                                                </Button>
                                                            </Box>
                                                        </Modal>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rowsDespathPlanList.map((row) => (
                                                    <TableRow key={row.id} selected={isSelected(row.id)}>

                                                        <TableCell>
                                                            <span
                                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                onClick={() => handleOnCellClick_DespatchPlanList(row)}
                                                            >
                                                                {row.DespatchOrderNo}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell>
                                                            {row.DespatchOrderDate
                                                                ? dayjs(row.DespatchOrderDate).format("DD-MMM-YYYY")
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell>{row.DespatchOrderStatus}</TableCell>
                                                        <TableCell sx={{textAlign:'right'}}>{row.TotalDPQty}</TableCell>
                                                        <TableCell sx={{textAlign:'right'}}>{row.TotalDOQty}</TableCell>
                                                        <TableCell sx={{textAlign:'right'}}>{row.TotalDOPendingQty}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </CustomTableContainer>
                            </Grid>

                            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" >
                                <DialogContent padding={0} style={{ padding: '0px', margin: '0px', backgroundColor: theme.palette.background.default }}>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <Box margin='0px 0px 0px 0px' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                                            <Box borderRadius={'20px'} padding={'8px'}  >
                                                <Typography variant="button" mt={1} fontSize={18} fontWeight={'bold'} style={{ textTransform: 'none' }}>Confirmed Orders</Typography>

                                                <Typography variant="h6" mb={0} style={{ color: '#B0B8C4' }}>
                                                    Confirmation Orders under selected Despatch Plan
                                                </Typography>
                                            </Box>

                                            <Box borderRadius={'20px'} padding={'8px'}  >

                                                <Tooltip title="Create New Delivery Order [Alt + N]" >
                                                    {isVisiblebtnCreateDespatchPlan && (
                                                        <Button variant='contained' color='secondary' style={{ marginRight: "2px", textTransform: 'none' }} size='small' startIcon={<AddIcon />} onClick={handleShowDispatchPlansEntry}>
                                                            Create Delivery Order
                                                            {/* <kbd style={{ marginLeft: '0.5rem', textDecoration: '' }}>Alt + N</kbd> */}
                                                        </Button>
                                                    )}
                                                </Tooltip>

                                                <Tooltip title="Add Orders to Existing Plan [Alt + N]" >
                                                    {isVisiblebtnAddSelectedCO && (
                                                        <Button variant='contained' style={{ backgroundColor: '#1769aa', textTransform: 'none' }} size='small' startIcon={<AddIcon />} onClick={handleShowDispatchPlansEntry}>
                                                            Cancel DP(Partial)
                                                            {/* <kbd style={{ marginLeft: '0.5rem', textDecoration: '' }}>Alt + N</kbd> */}
                                                        </Button>
                                                    )}
                                                </Tooltip>
                                            </Box>
                                        </Box>

                                        <Box
                                            display="grid"
                                            gridTemplateColumns="repeat(20, 1fr)"
                                            gridAutoRows={'520px'}
                                            gap="0px"
                                        >
                                            <Box
                                                gridColumn="span 20"
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{
                                                    "& .custom-header": {
                                                        fontWeight: 'bold',  // set bold font
                                                        fontSize: '0.85rem',  // adjust font size                                 
                                                    },
                                                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                                        color: `${colors.grey[100]} !important`,
                                                    },
                                                    "& .MuiCheckbox-root": {
                                                        color: `${colors.greenAccent[200]} !important`,
                                                    },
                                                }}
                                            >
                                                <DataGrid
                                                    // checkboxSelection
                                                    rowHeight={30}
                                                    pageSize={5}
                                                    rows={rowsConfirmedOrders}
                                                    columns={columnsConfirmedOrders}

                                                    slots={{ toolbar: GridToolbar }}
                                                    slotProps={{
                                                        toolbar: {
                                                            showQuickFilter: true,
                                                        },
                                                    }}
                                                />
                                            </Box>
                                        </Box>


                                    </Grid>
                                </DialogContent>
                            </Dialog>
                        </Grid>
                    </Box>
                </form>
            )}

            <DeliveryPlanActionMenu
                isVisible={isVisible_commanButtons}
                fromModule={fromModule}
                headerText={headerDespatchplan}
                btnSaveUpdate={btnSaveUpdate}
                btnSaveTooltip={btnSaveTooltip}
                btnSaveText={btnSaveText}
                btnCancel={btnCancel}
                btnApprove={btnApprove}
                btnAmendment={btnAmendment}
                btnPrint={btnPrint}
                handleBack={handleBackTofromDespacthPlanEntry}
                handleSave={() => handleSavePlanData(true)}
                handleCancel={handleCancel}
                handleApprove={(e) => handleApproveDeliveryOrderData(e)}
                handleAmendment={(e) => handleApproveDeliveryOrderData(e)}
                handlePrintPacking={handlePrintPackingListClick}
                handlePrintPick={handlePrintPickListClick}
            />

            {isVisible_CreateDespatchPlanEntry && (
                <Box m='10px'>

                    <CustomSnackbar
                        open={snackbarOpen}
                        message={alertMessage}
                        onClose={handleSnackbarClose}
                        type={alertsevierity}
                    />

                    <Divider />


                    <Box
                        sx={{
                            p: 2,
                            mb: 1,
                            borderRadius: "5px",
                            backgroundColor: "transparent",
                        }}
                    >
                        <Grid container spacing={2}>
                            {/* Delivery Order No */}
                            <Grid item xs={12} sm={6}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1">Delivery Order No</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            color='secondary'
                                            value={ShipmentOrderNO}
                                            onChange={(e) => SeShipmentOrderNO(e.target.value)}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* Delivery Order Date */}
                            <Grid item xs={12} sm={6}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1">Delivery Order Date</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <FormControl fullWidth size="small">
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format="DD-MMM-YYYY"
                                                    value={dayjs(OrderDate)}
                                                    minDate={dayjs()}
                                                    onChange={(date) => handlerOrderDate(date)}
                                                    slotProps={{
                                                        textField: { size: "small", variant: "outlined" },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* Despatch Plan No */}
                            <Grid item xs={12} sm={6}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1">Despatch Plan No</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            value={DespatchNo}
                                            disabled
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* Despatch Plan Date */}
                            <Grid item xs={12} sm={6}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1">Despatch Plan Date</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <FormControl fullWidth size="small">
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format="DD-MMM-YYYY"
                                                    value={dayjs(DespatchDate)}
                                                    minDate={dayjs()}
                                                    disabled
                                                    slotProps={{
                                                        textField: { size: "small", variant: "outlined" },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>




                    <Box style={{ marginBottom: "5px", marginTop: "2px", borderRadius: '5px 5px 5px 5px', backgroundColor: 'transparent' }}>


                        <Divider />


                        <Box sx={{ p: 2, borderRadius: "5px", backgroundColor: "transparent" }}>
                            <Grid container spacing={2}>
                                {/* Schedule Date */}
                                <Grid item xs={12} sm={6}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">Schedule Date</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format="DD-MMM-YYYY"
                                                    minDate={dayjs()}
                                                    color='secondary'
                                                    value={dayjs(ScheduleDate)}
                                                    onChange={(date) => handleScheduleDate(date)}
                                                    slotProps={{ textField: { size: "small", variant: "outlined", fullWidth: true } }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Shipment Mode */}
                                <Grid item xs={12} sm={6}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">Shipment Mode</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Autocomplete
                                                size="small"
                                                value={selectedShipmentMode || null}
                                                onChange={handleSelectShipmentMode}
                                                options={dataShipmentmode}
                                                getOptionLabel={(option) => option.Description || ""}
                                                isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                                                renderInput={(params) =>
                                                    <TextField {...params} label="Select Shipment Mode" variant="outlined" />}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Transporter */}
                                <Grid item xs={12} sm={6}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">Transporter</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Autocomplete
                                                size="small"
                                                fullWidth
                                                value={selectedTransporter || null}
                                                onChange={handleSelectTransporter}
                                                options={dataTransporter}
                                                getOptionLabel={(option) => option.Description || ""}
                                                isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Transporter"
                                                        error={!!(transporterError && transporterError.length)}
                                                        helperText={transporterError}
                                                        required
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Truck Number */}
                                <Grid item xs={12} sm={6}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">Truck Number</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Autocomplete
                                                size="small"
                                                fullWidth
                                                value={selectedTruckNo || null}
                                                onInputChange={handleiInputTruckNoChange}
                                                onChange={handleSelectTruckNo}
                                                options={dataTruckNo}
                                                getOptionLabel={(option) => option.Description || ""}
                                                isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                                                freeSolo
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        error={!!(truckNoError && truckNoError.length)}
                                                        helperText={truckNoError}
                                                        required
                                                        label="Select Truck Number"
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Driver Contact Number */}
                                <Grid item xs={12} sm={6}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">Driver Contact No.</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                size="small"
                                                type="number"
                                                color='secondary'
                                                fullWidth
                                                placeholder="Enter Driver Contact Number"
                                                variant="outlined"

                                                value={driverContactNo}
                                                onChange={(e) => setDriverContactNo(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Freight */}
                                <Grid item xs={12} sm={6}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">Freight</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Autocomplete
                                                size="small"
                                                fullWidth
                                                options={["To Pay", "Paid"]}
                                                value={freight}
                                                onChange={(event, newValue) => setFreight(newValue ?? null)}
                                                renderInput={(params) => (
                                                    <TextField {...params} placeholder="Select Freight Option" variant="outlined" />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* LR No */}
                                <Grid item xs={12} sm={6}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">LR No</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                color='secondary'
                                                label="Enter LR No"
                                                value={LRNo}
                                                onChange={(e) => SeLRNo(e.target.value)}
                                                variant="outlined"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* LR Date */}
                                <Grid item xs={12} sm={6}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="subtitle1">LR Date</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format="DD-MMM-YYYY"
                                                    value={dayjs(LRDate)}
                                                    color='secondary'
                                                    minDate={dayjs()}
                                                    onChange={(date) => handleLRDate(date)}
                                                    slotProps={{ textField: { size: "small", variant: "outlined", fullWidth: true } }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Remarks (full width row) */}
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={2} sm={2} md={2}>
                                            <Typography variant="subtitle1">Remarks</Typography>
                                        </Grid>
                                        <Grid item xs={10} sm={10} md={10}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Remarks"
                                                color='secondary'
                                                value={Remarks}
                                                onChange={(e) => SetRemarks(e.target.value)}
                                                variant="outlined"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>



                            </Grid>
                        </Box>

                        {(visibleAmendmentReason || isVisible_cancelDetail) && (
                            <Divider />)}

                        {visibleAmendmentReason && (
                            <Box sx={{ p: 2, borderRadius: "5px", backgroundColor: "transparent" }}>
                                <Grid container spacing={2}>

                                    <>


                                        <Grid item xs={12} sm={6}>
                                            <Grid container alignItems="center" spacing={2}>
                                                <Grid item xs={4}>
                                                    <Typography variant="subtitle1" color="secondary">Amendment Reason</Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        required
                                                        color='secondary'
                                                        label="Amendment Reason"
                                                        value={SAmendmentReason}
                                                        onChange={handleSelectAmendmentReason}
                                                        error={!!amendReasonError}
                                                        helperText={amendReasonError}
                                                        variant="outlined"
                                                    />
                                                </Grid>
                                            </Grid>

                                        </Grid>

                                    </>

                                </Grid>
                            </Box>)}
                        {isVisible_cancelDetail && (
                            <Box sx={{ p: 2, borderRadius: "5px", backgroundColor: "transparent" }}>
                                <Grid container spacing={2}>



                                    <>


                                        <Grid item xs={12} sm={6}>
                                            <Grid container alignItems="center" spacing={2}>
                                                <Grid item xs={4}>
                                                    <Typography variant="subtitle1" color="orange">Cancel Reason</Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        variant="outlined"
                                                        value={Reason}
                                                        onChange={handleEnterReason}
                                                        error={!!(ReasonError && ReasonError.length)}
                                                        helperText={ReasonError}

                                                        required
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>


                                        <Grid item xs={12} sm={6}>
                                            <Grid container alignItems="center" spacing={2}>
                                                <Grid item xs={4}>
                                                    <Typography variant="subtitle1" color="orange">Cancel Date</Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <FormControl
                                                        fullWidth
                                                        size="small"
                                                        required
                                                        error={!!(DateError && DateError.length)}
                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                format="DD-MMM-YYYY"
                                                                value={dayjs(cancelDate)}
                                                                onChange={handleDateChange}
                                                                slotProps={{
                                                                    textField: { size: "small", variant: "outlined" },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                        {DateError && DateError.length > 0 && (
                                                            <FormHelperText error>{DateError}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>



                                </Grid>
                            </Box>)}
                        <Divider />
                    </Box>



                    <Box style={{ backgroundColor: "transparent", borderRadius: '5px 5px 5px 5px', marginBottom: "3px", marginTop: "10px" }}>

                        <Box
                            sx={{
                                // backgroundColor: colors.primary[300],
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#FFFFFF', // Adjust font color based on theme mode
                            }}
                        >
                            <Typography variant="h6" fontWeight={'bold'} padding={1} >Confirmation Order Items</Typography>
                        </Box>


                        <Box style={{ padding: 1 }}>

                            <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>

                                <CustomTableContainer colors={colors}>
                                    <TableContainer >
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ textTransform: "uppercase", }}></TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Confirmation No</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Ship To Party</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Ship To Area</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Ship To City</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Ship To State</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Variety</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>GSM</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Width</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Length</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Color</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>UOM</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Requested Qty</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Confirmed Qty</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Planned Qty</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Shipped Qty</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Remarks</TableCell>
                                                    <TableCell sx={{ textTransform: "uppercase", }}>Reel/Bundle</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {rowsConfirmedOrdersDespacth.length > 0 ? (
                                                    rowsConfirmedOrdersDespacth.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                <IconButton onClick={() => handleOn_OrderItemsCellClick(row)}>
                                                                    <EditIcon color="secondary" fontSize='small' />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell >{row.SIConfirmationOrderNo}</TableCell>
                                                            <TableCell>{row.ShipToCustomer}</TableCell>
                                                            <TableCell>{row.ShipToArea}</TableCell>
                                                            <TableCell>{row.ShipToCity}</TableCell>
                                                            <TableCell>{row.ShipToState}</TableCell>
                                                            <TableCell>{row.SIVariety}</TableCell>
                                                            <TableCell sx={{ textAlign: "right" }}>{row.SIGSM}</TableCell>
                                                            <TableCell sx={{ textAlign: "right" }}>{row.SIWidth}</TableCell>
                                                            <TableCell sx={{ textAlign: "right" }}>{row.SILength}</TableCell>
                                                            <TableCell >{row.SIColor}</TableCell>
                                                            <TableCell >{row.SIUnit}</TableCell>
                                                            <TableCell sx={{ textAlign: "right" }}>{row.SIRequested_Qty}</TableCell>
                                                            <TableCell sx={{ textAlign: "right" }}>{row.SIConfirmed_Qty}</TableCell>
                                                            <TableCell sx={{ textAlign: "right" }}>{row.SIPlanned_Qty}</TableCell>
                                                            <TableCell sx={{ textAlign: "right" }}>{row.SIShipped_Qty}</TableCell>
                                                            <TableCell >{row.SIRemarks}</TableCell>
                                                            <TableCell sx={{ textAlign: "right" }}>{row.ReelBundleCount}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={16} align="center">
                                                            No records found
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </CustomTableContainer>

                            </ResponsiveBox>


                        </Box>
                    </Box>

                    <Box display="flex" mt={1} justifyContent="flex-end">
                        <Box >
                            <Card sx={{ backgroundColor: 'transparent', borderRadius: '5px 5px 5px 5px' }}>
                                <Box
                                    sx={{

                                        display: 'flex',
                                        padding: 0,
                                        height: '35px',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#FFFFFF', // Adjust font color based on theme mode
                                    }}
                                >
                                    <Typography variant="h6" ml={1} >
                                        Summary
                                    </Typography>
                                </Box>
                                <Divider />

                                <TableContainer >
                                    <Table size='small'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">SHIP-TO AREA</TableCell>
                                                <TableCell align="center">SHIP-TO CITY</TableCell>
                                                <TableCell align="center">SHIP-TO STATE</TableCell>
                                                <TableCell align="center">TOTAL QTY</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {plannedQtyData.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell align="center">{row.ShipToCity}</TableCell>
                                                    <TableCell align="center">{row.ShipToCity}</TableCell>
                                                    <TableCell align="center">{row.ShipToCity}</TableCell>
                                                    <TableCell align="center">{row.TotalQty}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Box>
                    </Box>
                </Box>
            )}

            {isVisible_DespatchItem && (
                <Box m='0px'>
                    {open && (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backdropFilter: 'blur(2px)', // Adjust the blur intensity
                            zIndex: 1000, // Adjust the z-index to be above other content
                        }}
                        ></div>
                    )}

                    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" >
                        <DialogContent padding={0} style={{ padding: '0px', margin: '0px', backgroundColor: theme.palette.background.default }}>
                            <Box style={{ borderRadius: '5px 5px 5px 5px', backgroundColor: "transparent", marginBottom: "0px", marginTop: "0px" }}>
                                <Box
                                    sx={{
                                        // backgroundColor: colors.primary[300],
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#FFFFFF', // Adjust font color based on theme mode
                                    }}
                                >
                                    <Typography variant="h5" fontWeight={''} padding={1} >Select the Items for Delivery Order</Typography>

                                    <Tooltip title="Close" onClick={handleClose}>
                                        <IconButton>
                                            <CancelIcon style={{ color: "#ef5350" }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>

                                <Box style={{ padding: 2, borderRadius: '5px 5px 5px 5px', backgroundColor: "transparent", }}>
                                    <Box
                                        display="grid"
                                        gridTemplateColumns="repeat(20, 1fr)"
                                        gridAutoRows="500px"
                                        gap="0px"
                                    >
                                        <Box
                                            gridColumn="span 20"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            sx={{
                                                "& .custom-header": {
                                                    fontWeight: 'bold',  // set bold font
                                                    fontSize: '0.85rem',  // adjust font size                                 
                                                },
                                                borderRadius: '15px 15px 15px 15px',
                                                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                                    color: `${colors.grey[100]} !important`,
                                                },
                                                "& .MuiCheckbox-root": {
                                                    color: `${colors.greenAccent[200]} !important`,
                                                },
                                            }}
                                        >
                                            {isVisibleReelItem && (
                                                <DataGrid
                                                    style={{ marginTop: '0px' }}
                                                    rows={rowsReelItemsFiltered || []}
                                                    columns={columnsReelItems}
                                                    // checkboxSelection
                                                    rowHeight={30}
                                                    pageSize={5}
                                                    slots={{ toolbar: GridToolbar }}
                                                    slotProps={{
                                                        toolbar: {
                                                            showQuickFilter: true,
                                                        },
                                                    }}

                                                />
                                            )}

                                            {isVisibleSheetItem && (
                                                <DataGrid
                                                    style={{ marginTop: '0px' }}
                                                    rows={rowsSheetItemsFiltered || []}
                                                    columns={columnsSheetItems}
                                                    // checkboxSelection
                                                    rowHeight={30}
                                                    pageSize={5}
                                                    slots={{ toolbar: GridToolbar }}
                                                    slotProps={{
                                                        toolbar: {
                                                            showQuickFilter: true,
                                                        },
                                                    }}

                                                />
                                            )}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </DialogContent>
                    </Dialog>


                </Box>
            )}

            {viewreport && (

                <DeliverOrderPickListReport handleBackToSalesOrderDetails={handleBackTofromDespacthPlanEntry} picklistData={picklistData} />
            )}
        </Box >
    );
};

export default DeliveryOrderList;